// ============================================================================
// CATALOGO DE FUNCIONALIDADES DO BOT MARTELINHO
// ----------------------------------------------------------------------------
// REGRA (obrigatoria): sempre que uma NOVA funcionalidade for adicionada ao bot
// (backend/src/modules/martelinho/services/botService.js), adicione aqui uma
// entrada correspondente NO MESMO COMMIT. Esta lista alimenta a tela
// "Martelinho > Funcionalidades" e e a documentacao viva do que o bot faz.
//
// Campos:
//   chave      - identificador unico (kebab-case)
//   titulo     - nome exibido
//   comando    - como o usuario aciona no WhatsApp (ex.: "Menu > 1")
//   permissao  - flag em siti_martelinho_usuarios que libera a opcao
//   descricao  - o que a opcao faz, em linguagem de negocio
// ============================================================================

const FUNCIONALIDADES = [
  {
    chave: 'venda-sem-estoque',
    titulo: 'Alterar venda sem qtde. disponível',
    comando: 'Menu › 1',
    permissao: 'pode_habilitar',
    descricao:
      'Libera ou bloqueia a venda de um produto sem estoque disponível (campo semdisp do ERP). '
      + 'O bot pede o código do produto e a ação desejada (liberar/bloquear) e registra a alteração no histórico.',
  },
  {
    chave: 'estoque-disponivel',
    titulo: 'Consultar estoque disponível',
    comando: 'Menu › 2  ou  "estoque <código>"',
    permissao: 'pode_consultar_estoque_disponivel',
    descricao:
      'Mostra o estoque disponível (quantidade − reservas) por filial, com média mensal de vendas, '
      + 'preços à vista e a prazo, e os pedidos de compra a chegar.',
  },
  {
    chave: 'estoque-bruto',
    titulo: 'Consultar estoque bruto',
    comando: 'Menu › 3',
    permissao: 'pode_consultar_estoque_bruto',
    descricao:
      'Mostra o estoque bruto (quantidade total, sem descontar reservas) por filial, com média mensal.',
  },
  {
    chave: 'lote-pisos',
    titulo: 'Consultar lote de pisos',
    comando: 'Menu › 4',
    permissao: 'pode_consultar_lote',
    descricao:
      'Consulta os lotes de um produto em uma filial específica, com quantidade e reserva por lote, '
      + 'além dos totais em lote e em estoque.',
  },
  {
    chave: 'bloquear-devolucao',
    titulo: 'Bloquear/Permitir Devolução',
    comando: 'Menu › 5',
    permissao: 'pode_bloquear_devolucao',
    descricao:
      'Bloqueia ou permite a devolução de um produto (campo BLOQUEIADEVOLUCAO do ERP). '
      + 'Registra a alteração no histórico.',
  },
  {
    chave: 'aprovar-pedidos-mk',
    titulo: 'Aprovar Pedidos por MK',
    comando: 'Menu › 6',
    permissao: 'autorizar_pedido',
    descricao:
      'Aprova pedidos pendentes por markup: mostra valor e markup do pedido, pede confirmação e a senha '
      + 'de autorização, e libera a pendência diretamente no ERP.',
  },
  {
    chave: 'comando-rapido-estoque',
    titulo: 'Comando rápido de estoque',
    comando: '"estoque <código>"',
    permissao: 'pode_consultar_estoque_disponivel',
    descricao:
      'Atalho: digitar "estoque 12345" consulta o estoque disponível do produto direto, sem passar pelo menu.',
  },
];

export default FUNCIONALIDADES;
